
import loginFun from "@/utils/cc-webapp/login.js";

import CheckIcon from 'vux/src/components/check-icon/index.vue'


export default {
name: "registerSuccess",
components: {
CheckIcon,

},
data() {
return {
imgbg1: require("@/assets/image/photo/bg1.png"),
imgvipCar: require("@/assets/image/photo/vipCar.png"),
iconclose: require("@/assets/image/close.png"),
userInfo: {},
isNotice: true,
isNoticePopShow: false
};
},

mounted: function() {
this.$ccDialog.init(true);

if (this.UTILS.chackNative()) {
native.webViewOnload();
native.hideNavigation();
}
},

methods: {
isNoticeShowChange() {
if (!this.isNotice) {
this.isNoticePopShow = true;
}
},
isNoticePopChoose(type) {
if (type) {
this.isNoticeChange(); 
} else {
this.isNotice = true;
}
this.isNoticePopShow = false;
},

isNoticeChange() {
let flag = this.isNotice;
let userId = this.userInfo.id;

this.GLOBAL_.ccRequest
.doAxios(this.CONFIG.NEWS.GET_SWITCH, { userId: userId }, "GET")
.then(res => {
res.entity.openContent = flag;
let postData = {
id: res.entity["id"],
openSys: res.openSys




};

this.updateSwitch(postData);
})
.catch(err => {
let res = err.response;
native.showToast(res.data.message);
});
},

updateSwitch(postData) {
this.GLOBAL_.ccRequest
.doSessionAxios(this.CONFIG.NEWS.UPDATE_SWITCH, postData, "POSTJSON")
.then(resData => {

})
.catch(err => {
let res = err.response;
native.showToast(res.data.message);
});
},


onReturn() {
this.GLOBAL_.ccApp.closeW();
},


onToResume() {
let obj = {};
obj["path"] = "/app/personal";
this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
},

getUserInfo() {
let obj = {};
obj["session"] = this.user_session;
this.GLOBAL_.ccRequest
.doSessionAxios(this.CONFIG.USER.GETUSERINFO, {}, "GET")
.then(res => {
this.userInfo = res;

var umengObj = {};
umengObj["page"] = "註冊成功頁";

this.UTILS.umengReport("interview", umengObj);

})
.catch(err => {
let res = err.response;
native.showToast(
this.$t("REGISTER_SUCCESS_LANG.getUserDataErr") +
":" +
res.data.message
);
});
}
},
created() {




this.user_session = this.$route.query.session;

this.getUserInfo();
}
};



// WEBPACK FOOTER //
// ./src/pages/login/success.vue